import { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useAtom } from 'jotai'

import { Endpoints, UserRole, type MunicipalityAward } from '@/types'
import MunicipalityAwardActions from '@/components/municipality-awards/actions'
import DocumentsList from '@/components/attachments/documents-list'
import { selectedMunicipalityIdAtom } from '@/state'
import MunicipalityAwardForm from '@/components/forms/municipality-award'
import PermissionsGate from '@/components/permissions-gate'
import DocumentsPreview from './documents-preview'

function MunicipalityAwardSingle({
    municipalityAward,
}: {
    municipalityAward: MunicipalityAward,
}) {

    const [edit, setEdit] = useState<boolean>(false)

    const [municipalityId] = useAtom(selectedMunicipalityIdAtom)

    return (
        edit ?
            <MunicipalityAwardForm
                municipalityAward={municipalityAward}
                closeCallback={() => setEdit(false)}
            />
            :
            <Box sx={theme => ({
                position: 'relative',
                border: `1px solid ${theme.palette.customGrey.cardBorder}`,
                borderRadius: 2.5,
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                maxWidth: 720,
            })}>
                <Typography variant="h3" component="h3" mb={1} pr={4}>
                    {municipalityAward.title}
                </Typography>
                {municipalityAward.year &&
                    <Typography variant="subtitle1" component="div" mb={1} sx={{ fontStyle: 'italic' }}>
                        {municipalityAward.year}
                    </Typography>
                }
                {municipalityAward.description &&
                    <Typography variant="body1" component="div" mb={1}>
                        {municipalityAward.description}
                    </Typography>
                }
                <PermissionsGate
                    userRoles={[
                        UserRole.admin,
                        UserRole.municipalityOfficial,
                    ]}
                >
                    <Box sx={{
                        position: 'absolute',
                        top: 2,
                        right: 2,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        borderRadius: '1rem',
                    }}>
                        <MunicipalityAwardActions
                            municipalityAward={municipalityAward}
                            setEdit={setEdit}
                        />
                    </Box>
                </PermissionsGate>
                <DocumentsPreview attachments={municipalityAward.documents}/>
                <Box pt={2} />
                <DocumentsList
                    documents={municipalityAward.documents}
                    endpoint={Endpoints.municipalityAward}
                    entityId={municipalityAward.id}
                    invalidateQueryKey={['municipalityAwards', municipalityId]}
                />
            </Box>
    )
}

export default MunicipalityAwardSingle
